import Home from './Pages/Home';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CreateCard from './Pages/CreateCard';
import Sign from './Pages/Sign';
import Quiz from './Pages/Quiz'
import Allcards from './Pages/AllCards';
import {  useUser} from './UserContext';
import LoginAcc from './Pages/LoginAcc';
import History from './Pages/History';
import Debug from './Pages/Debug';
function App() {
  const {currentUser,userData} = useUser()
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={currentUser?<Home/>:<Sign/>}/>
          <Route path='/create' element={<CreateCard/>}/>
          <Route path='/signup' element={<Sign/>}/>
          <Route path='/login' element={<LoginAcc/>}/>
          <Route path='/quiz' element={<Quiz/>}/>
          <Route path='/profile' element={<History/>}/>
         
          <Route path='/all-flashcards' element={<Allcards/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;